import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ActiveGlass } from '../../../assests/images/LandingAssets/ActiveGlass.svg';
import { ReactComponent as BulletEllipse } from '../../../assests/images/LandingAssets/BulletEllipse.svg';
import { ReactComponent as InActiveGlass } from '../../../assests/images/LandingAssets/InactiveGlass.svg';
import { ReactComponent as ActiveAssess } from '../../../assests/images/LandingAssets/ActiveAssess.svg';
import { ReactComponent as InActiveAssess } from '../../../assests/images/LandingAssets/InActiveAssess.svg';
import { ReactComponent as ActiveBenchMark } from '../../../assests/images/LandingAssets/ActiveBenchMark.svg';
import { ReactComponent as InActiveBenchMark } from '../../../assests/images/LandingAssets/InActiveBenchMark.svg';
import { ReactComponent as ActiveForesee } from '../../../assests/images/LandingAssets/ActiveForesee.svg';
import { ReactComponent as InActiveForesee } from '../../../assests/images/LandingAssets/InActiveForesee.svg';
import { ReactComponent as ActiveBond } from '../../../assests/images/LandingAssets/ActiveBond.svg';
import { ReactComponent as InActiveBond } from '../../../assests/images/LandingAssets/InActiveBond.svg';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const Wrapper = styled.div`
  padding-top: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 60px;
  background: #e6f0f0;
`;
const Container = styled.div`
  width: 1140px;
  border-radius: 20px;
  margin-top: 45px;
  background: #ffffff;
  padding-top: 60px;
  @media only screen and ${device.tablet} {
    max-width: 345px;
    margin-top: 30px;
  }
`;

const TabBar = styled.div`
  margin-left: 60px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  @media only screen and ${device.tablet} {
    flex-wrap: wrap;
    row-gap: 15px;
    column-gap: 10px;
    justify-content: center;
  }
`;

const Tab = styled.div`
  display: flex;
  align-items: center;
  padding-right: 15px;
  margin-right: 30px;
  padding-bottom: 15px;
  color: ${(props) => (props.active ? '#063257' : '#BDBDBD')};
  background: none;
  border-bottom: ${(props) =>
    props.active ? '1px solid #063257' : '1px solid #BDBDBD'};
  &:hover {
    cursor: pointer;
    color: #063257;
    border-bottom: 1px solid #063257;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  // border-radius: 20px;
  margin-top: 60px;
  overflow: hidden;
  padding-left: 10px;
  margin-left: 60px;
  @media only screen and ${device.tablet} {
    flex-direction: column;
    margin-left: 30px;
  }
`;

const TabText = styled.div`
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  margin-left: 15px;
  line-height: normal;
  @media only screen and ${device.tablet} {
    font-size: 16px;
  }
`;
const TextSection = styled.div``;

const Title = styled.div`
  font-family: Inter;
  font-weight: 700;
  font-size: 28px;

  vertical-align: middle;
  color: #2a876c;
  text-align: left;
  @media only screen and ${device.tablet} {
    font-size: 20px;
  }
`;

const Description = styled.p`
  font-family: Inter;
  font-weight: 400;
  font-size: 20px;

  vertical-align: middle;
  color: #051a3a;
  text-align: left;
  max-width: 437px;
  @media only screen and ${device.tablet} {
    font-size: 16px;
    max-width: 297px;
  }
`;

const ImageSection = styled.div`
  border-top-left-radius: 10px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 30px;
  padding-top: 30px;
  padding-left: 30px;
  background: linear-gradient(
    117.4deg,
    rgba(189, 218, 209, 0.3) 1.15%,
    rgba(234, 243, 240, 0.3) 98.85%
  );
  @media only screen and ${device.tablet} {
    padding-top: 15px;
    padding-left: 15px;
  }
`;

const ImageWrapper = styled.div`
  border-top-left-radius: 10px;
  overflow: hidden;
`;
const TitleText = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 32px;

  text-align: center;
  vertical-align: middle;
  background-image: linear-gradient(90deg, #063257 0%, #006867 100%);
  color: transparent;
  background-clip: text;
  @media only screen and ${device.tablet} {
    font-size: 28px;
  }
`;

const HeaderText = styled.div`
  margin-top: 10px;
  font-family: Inter;
  font-weight: 400;
  font-size: 18px;

  text-align: center;
  vertical-align: middle;
  color: #636363;
  max-width: 734px;
  @media only screen and ${device.tablet} {
    font-size: 14px;
    max-width: 345px;
  }
`;

const HowItWorks = () => {
  const content = [
    {
      titleText: 'Choose Your Channels',
      description:
        'Scan insights from 50+ digital sources for a 360° audience view.',
      ImageComp: require('../../../assests/images/LandingAssets/ChooseYourChannels.png'),
    },
    {
      titleText: 'Build Your Query',
      description:
        'Simply ask BrandAstra what you need to know, with no complex setup required.',
      ImageComp: require('../../../assests/images/LandingAssets/BuildYourQuery.png'),
    },
    {
      titleText: 'Hit Run & Get Instant Insights',
      description:
        'BrandAstra’s AI analyzes real-time data and delivers actionable insights.',
      ImageComp: require('../../../assests/images/LandingAssets/HitRun.png'),
    },
    {
      titleText: ' Use AI Assistant to Drill Deeper',
      description:
        'Discover and visualize exactly what you need in your report dashboard with the help of an AI assistant that uncovers patterns and surfaces critical insights, so you can make smarter, data-driven marketing decisions.',
      ImageComp: require('../../../assests/images/LandingAssets/AI.png'),
    },
  ];
  const [active, setActive] = useState(0);

  return (
    <Wrapper>
      <TitleText>How it Works</TitleText>
      <HeaderText>
        We built BrandAstra to bridge the gap between fragmented data and
        AI-powered marketing intelligence. In just a few clicks, you can build a
        query, choose channels, and hit run, letting AI do the heavy lifting.
      </HeaderText>
      <Container>
        <TabBar>
          <Tab
            active={active === 0}
            onClick={() => {
              setActive(0);
            }}
          >
            <TabText>Step 1</TabText>
          </Tab>
          <Tab
            onClick={() => {
              setActive(1);
            }}
            active={active === 1}
          >
            <TabText>Step 2</TabText>
          </Tab>
          <Tab
            active={active === 2}
            onClick={() => {
              setActive(2);
            }}
          >
            <TabText>Step 3</TabText>
          </Tab>
          <Tab
            active={active === 3}
            onClick={() => {
              setActive(3);
            }}
          >
            <TabText>Step 4</TabText>
          </Tab>
        </TabBar>

        <Content>
          <TextSection>
            <Title>{content[active]?.titleText}</Title>
            <Description>{content[active]?.description}</Description>
          </TextSection>
          <ImageSection>
            <ImageWrapper>
              <img
                src={content[active]?.ImageComp}
                width={window?.innerWidth < 728 ? '290px' : '508px'}
              />
            </ImageWrapper>
          </ImageSection>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default HowItWorks;
